'use client'

import SectionTitle, {SectionTitleTheme} from "@/app/components/atomic/molecules/SectionTitle";
import Breadcrumb from "@/app/components/atomic/molecules/Breadcrumb";
import React from "react";
import {usePathname} from "next/navigation";
import {TBreadcrumb} from "@/app/models/wp";
import BlurShape from "@/app/components/atomic/atoms/BlurShape";
import {Products} from "@/app/enums/Products";
import {getThemeColors} from "@/app/constants/theme";
import {getProductName} from "@/app/utils/context-utils";

export default function PageHead({title, breadcrumb}: {title: string, breadcrumb?: TBreadcrumb}) {
    const pathname = usePathname()
    const product = pathname ? getProductName(pathname) : Products.COMMON
    const theme = product === Products.COMMON
        ? "white"
        : getThemeColors(product).primary as SectionTitleTheme

    return (
        <div className="bg-neutral w-full flex items-center relative">
            <div className="flex flex-col gap-2 max-w-[960px] w-full mx-auto pb-10 pt-5 px-4 z-10">
                {breadcrumb && <Breadcrumb breadcrumb={breadcrumb} />}

                <SectionTitle
                    level="h1"
                    theme={theme}
                    className="md:max-w-[640px]"
                >
                    <span dangerouslySetInnerHTML={{__html: title}} />
                </SectionTitle>
            </div>

            <BlurShape top="-50px" width="500px" height="400px" translateX="-400px" className="z-[1] hidden md:block" />
        </div>
    )
}
